module.exports = __webpack_public_path__ + "static/18-7060c7099bec2a3470df5f55ea8944fb.png";